import { Center, Loader } from '@mantine/core';
import { AdminSectionEnum } from '@routellers/types/dist/admin/admin-permissions';
import { Navigate, Route, Routes } from 'react-router-dom';

import { AppLayout } from './components/app-layout';
import { AuthLayout } from './components/auth-layout';
import { RequirePermission } from './components/require-permission';
import { ActivitiesPage } from './pages/activities';
import { AttractionsPage } from './pages/attractions';
import { AuthorsPage } from './pages/authors';
import { CitiesPage } from './pages/cities';
import { CollectionsPage } from './pages/collections';
import { CityDetailPage } from './pages/city-detail';
import { DashboardPage } from './pages/dashboard';
import { DistrictsPage } from './pages/districts';
import { EstablishmentsPage } from './pages/establishments';
import { FoodsPage } from './pages/foods';
import { LoginPage } from './pages/login';
import { OrdersPage } from './pages/orders';
import { PeoplePage } from './pages/people';
import { PurchasesPage } from './pages/purchases';
import { QaPage } from './pages/qa';
import { QuestsPage } from './pages/quests';
import { ReviewsPage } from './pages/reviews';
import { RoutesPage } from './pages/routes';
import { TranslationsPage } from './pages/translations';
import { UsersPage } from './pages/users';
import { VenuesPage } from './pages/venues';
import { WikiPage } from './pages/wiki';
import { useAuth } from './providers/auth-context';

export const App = () => {
    const { admin, initializing } = useAuth();

    if (initializing) {
        return (
            <Center h='100vh'>
                <Loader />
            </Center>
        );
    }

    if (!admin) {
        return (
            <Routes>
                <Route element={<AuthLayout />}>
                    <Route path='/login' element={<LoginPage />} />
                </Route>
                <Route path='*' element={<Navigate to='/login' replace />} />
            </Routes>
        );
    }

    return (
        <Routes>
            <Route element={<AppLayout />}>
                <Route
                    path='/'
                    element={
                        <RequirePermission section={AdminSectionEnum.DASHBOARD}>
                            <DashboardPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/cities'
                    element={
                        <RequirePermission section={AdminSectionEnum.CITIES}>
                            <CitiesPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/cities/:cityId'
                    element={
                        <RequirePermission section={AdminSectionEnum.CITIES}>
                            <CityDetailPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/quests'
                    element={
                        <RequirePermission section={AdminSectionEnum.QUESTS}>
                            <QuestsPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/routes'
                    element={
                        <RequirePermission section={AdminSectionEnum.ROUTES}>
                            <RoutesPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/people'
                    element={
                        <RequirePermission section={AdminSectionEnum.PEOPLE}>
                            <PeoplePage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/attractions'
                    element={
                        <RequirePermission section={AdminSectionEnum.ATTRACTIONS}>
                            <AttractionsPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/collections'
                    element={
                        <RequirePermission section={AdminSectionEnum.ATTRACTIONS}>
                            <CollectionsPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/establishments'
                    element={
                        <RequirePermission section={AdminSectionEnum.ESTABLISHMENTS}>
                            <EstablishmentsPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/districts'
                    element={
                        <RequirePermission section={AdminSectionEnum.DISTRICTS}>
                            <DistrictsPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/foods'
                    element={
                        <RequirePermission section={AdminSectionEnum.FOODS}>
                            <FoodsPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/authors'
                    element={
                        <RequirePermission section={AdminSectionEnum.AUTHORS}>
                            <AuthorsPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/venues'
                    element={
                        <RequirePermission section={AdminSectionEnum.VENUES}>
                            <VenuesPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/activities'
                    element={
                        <RequirePermission section={AdminSectionEnum.ACTIVITIES}>
                            <ActivitiesPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/orders'
                    element={
                        <RequirePermission section={AdminSectionEnum.ORDERS}>
                            <OrdersPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/purchases'
                    element={
                        <RequirePermission section={AdminSectionEnum.PURCHASES}>
                            <PurchasesPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/reviews'
                    element={
                        <RequirePermission section={AdminSectionEnum.REVIEWS}>
                            <ReviewsPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/translations'
                    element={
                        <RequirePermission section={AdminSectionEnum.TRANSLATIONS}>
                            <TranslationsPage />
                        </RequirePermission>
                    }
                />
                <Route
                    path='/qa'
                    element={
                        <RequirePermission section={AdminSectionEnum.QA}>
                            <QaPage />
                        </RequirePermission>
                    }
                />
                <Route path='/wiki' element={<WikiPage />} />
                <Route path='/wiki/:slug' element={<WikiPage />} />
                <Route
                    path='/users'
                    element={
                        <RequirePermission section={AdminSectionEnum.USERS}>
                            <UsersPage />
                        </RequirePermission>
                    }
                />
            </Route>
            <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
    );
};
